/* eslint-disable react-hooks/exhaustive-deps */

import React, { useState, useEffect } from "react";
import Tab from "react-bootstrap/Tab";
import { Tabs } from "react-bootstrap";
import BillingDetails from "./SettingTabs/BillingDetails/BillingDetails";
import "./style.css";
import CompanyDetails from "./SettingTabs/CompanyDetails";
import EmailTemplates from "./SettingTabs/EmailTemplates";
import ManageUsers from "./Users/ManageUsers";
import { useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";
import { authRoles } from "../../../navigation/route-config";
import { useQuery } from "../Auth/ResetPassword/ResetPassword";

const Settings = () => {
  let navigate = useNavigate();
  let query = useQuery();
  const [key, setKey] = useState("manageUser");
  const user = useSelector((state) => state.user.data);

  useEffect(() => {
    setKey(query.get("tab") || "manageUser");
  }, [query]);

  return (
    <div className="main">
      <Tabs
        className="setting-tab-btns"
        defaultActiveKey="manageUser"
        activeKey={key}
        onSelect={(k) => {
          navigate("/settings?tab=" + k);
        }}
      >
        <Tab eventKey="manageUser" title="Manage User">
          <div style={{ height: "calc(100vh - 140px)", overflowY: "auto" }}>
            {key === "manageUser" && <ManageUsers />}
          </div>
        </Tab>
        <Tab eventKey="companyDetails" title="Company Details">
          <div style={{ height: "calc(100vh - 140px)", overflowY: "auto" }}>
            {key === "companyDetails" && <CompanyDetails />}
          </div>
        </Tab>
        <Tab eventKey="emailTemplates" title="Email Templates">
          <div style={{ height: "calc(100vh - 140px)", overflowY: "auto" }}>
            {key === "emailTemplates" && <EmailTemplates />}
          </div>
        </Tab>
        {user?.role !== authRoles.ultraAdmin &&
          !user?.is_consultant &&
          !user?.is_lead_inspector && (
            <Tab eventKey="billingDetails" title="Billing Details">
              <div style={{ height: "calc(100vh - 140px)", overflowY: "auto" }}>
                {key === "billingDetails" && <BillingDetails />}
              </div>
            </Tab>
          )}
      </Tabs>
    </div>
  );
};

export default Settings;
